import angular from 'angular';
import template from './template.html';
import './item';
import './style.scss';

export class CandidatesList {
    /* @ngInject */
    constructor($scope) {
        this.$scope = $scope;
    }
}

export const CandidatesListConfiguration = {
    template,
    bindings: {
        candidates: '<',
        onCandidateClick: '&',
        onCandidateSelect: '&',
    },
    controller: CandidatesList,
    controllerAs: 'candidatesListCtrl'
};

angular.module('TALENYA-FE').component('candidatesList', CandidatesListConfiguration);
